<template>
   <div class="BchSubscriptionBilling">
      <div class="body">
         <div class="taskName">{{ service.name }}</div>
         <pre class="billingText">{{ service.serviceBillingText }}</pre>
         <div class="grid"
            :style="gridStyle">
            <div v-for="(record, index ) in services"
               :key="index"
               class="gridRow">
               <div class="description">{{ record.text }}</div>
               <div class="count">{{ record.count }} </div>
               <div class="price">{{ record.count ? toCHF(record.rate) : '' }} </div>
               <div class="discount">
                  <template v-if="record.discount">
                     {{ record.discount }}%
                  </template>
               </div>
               <div class="value">{{ toValue(record.value) }}</div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import InputTime from '@components/Form/InputTime.vue';
import Switcher from '@components/Form/Switcher.vue';

import Textarea from '@components/Form/Textarea.vue';
import { minutes } from 'src/utils/utils'
export default {
   name: 'BchSubscriptionBilling',
   components: {
      InputTime,
      Switcher,
      Textarea
   },
   props: {
      service: { required: true, type: Object },
      mode: { required: false, default: 'view' },
      readonly: { required: false, default: false }
   },
   data() {
      return {
      }
   },
   methods: {
      toCHF(value) {
         if (!value) return '--'
         return Number(value).toFixed(2)
      },
      toValue(value) {
         if (!value) return null
         return Number(value).toLocaleString('de-ch', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
         })
      },
      toDuration(value) {
         if (!value) return null
         return minutes.toFormatDecimal(value).toFixed(1) + 'Std'
      }
   },
   computed: {
      services() {
         return this.service.services
      },
      settings() {
         return this.service.settings
      },
      gridColumns() {
         let columns = [
            { id: 'description', title: 'Bezeichnung', width: '1fr' },
            { id: 'count', title: 'Anzahl', width: 'max-content' },
            { id: 'price', title: 'Preis', width: '85px' },
            { id: 'discount', title: 'Rabatt', width: '45px' },
            { id: 'value', title: 'Betrag', width: 'minmax(85px, max-content)' }
         ]
         return columns
      },
      gridStyle() {
         return {
            gridTemplateColumns: this.gridColumns.map(column => `[${column.id}] ${column.width}`).join(' ')
         }
      },
      showTextArea() {
         if (this.mode == 'edit') return true
         return this.service.billingText ? true : false
      }
   },
}
</script>

<style scoped>
.BchSubscriptionBilling {
   display: inline-flex;
   flex-direction: column;
   row-gap: 10px;
   padding: 15px 0;
   width: 100%;
}

.body {
   display: flex;
   flex-direction: column;
   row-gap: 5px;
}

.taskName {
   font-weight: 500;
   line-height: 18px;
}

pre.billingText {
   white-space: pre;
}

.noData {
   color: #a6a6a6;
}

.gridRow {
   display: contents;
}


.grid {
   display: grid;
   width: 100%;
}

.gridRow>* {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   height: 24px;
}

.grid .description {
   grid-column: description;
}

.grid .count {
   grid-column: count;
   padding: 0 5px;
   display: flex;
   justify-content: center;
}

.grid .price {
   grid-column: price;
   padding: 0 5px;
   display: flex;
   justify-content: flex-end;

}

.grid .discount {
   grid-column: discount;
   padding: 0 5px;
   display: flex;
   justify-content: flex-end;
}

.grid .value {
   grid-column: value;
   padding-left: 5px;
   justify-content: flex-end;
}
</style>